function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoNvidia(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.99 9.172c2.302 0 3.67 1.806 3.67 1.806l-1.873 1.59c-.842-1.412-1.123-2.036-2.524-2.206v4.017c.318.106.67.17 1.062.17 2.734 0 5.283-3.566 5.283-3.566S13.248 7.757 9.65 7.87a6.73 6.73 0 00-.388.022v1.324c.241-.028.484-.043.726-.044zm-.727-4.333v1.979a6.93 6.93 0 01.388-.023c5.001-.17 8.26 4.132 8.26 4.132s-3.743 4.586-7.64 4.586c-.338 0-.675-.03-1.008-.09v1.224c.27.034.548.055.837.055 3.63 0 6.253-1.869 8.794-4.077.422.34 2.147 1.167 2.501 1.529-2.416 2.038-8.046 3.679-11.237 3.679a9.631 9.631 0 01-.895-.046v1.719h13.792V4.839H9.263zm-2.507 6.675s1.097-1.323 2.502-1.153l.005.001V9.216c-2.675.29-4.287 2.09-4.287 2.09s.931 3.515 4.287 4.118v-1.045c-1.892-.64-2.507-2.865-2.507-2.865zm-3.454-.36s1.989-2.957 5.961-3.262V6.818c-4.399.356-8.208 4.109-8.208 4.109s2.158 6.285 8.208 6.86v-1.14c-4.44-.563-5.96-5.494-5.96-5.494z"
  }));
}

SvgLogoNvidia.clsName = 'icon-uc-social__logo-nvidia';
SvgLogoNvidia.remarkName = 'unknown';
export default SvgLogoNvidia;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoNvidia.js
// module id = 2249
// module chunks = 17 18